import React from "react";
import SkillForm from "./skillForm";
import { Profile, Ratings } from "../../types";
import { _ } from "libs";

type Props = {
	profile: Profile;
	ratings: Ratings;
	onChange: Function;
};

export function Step5({ profile, ratings, onChange }: Props) {
	return (
		<div className="box onboardingStep5">
			<div className="boxLeader">
				<h2>{_("onboarding.skillSection.heading")}</h2>
				<div className="illustration player_backhand" />
			</div>
			<div className="boxContent">
				<p>{_("onboarding.skillSection.content")}</p>
				<SkillForm profile={profile} onChange={onChange} ratings={ratings} />
			</div>
		</div>
	);
}

export default Step5;
